import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { HttpRequest, HttpHandler, HttpInterceptor } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { TralalereService } from "./tralalere.service";


@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor{

  constructor(@Inject(LOCALE_ID) public locale: string, private trala: TralalereService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let tokenReq: HttpRequest<any>;
    let customHeaders 
    if (req.url.startsWith(this.trala.tralalereUrl + "/jwt/")) {
      // demande de token par identifiants : l'en-tête Authorization est déjà posé et
      // des en-têtes custom en plus élargiraient inutilement le preflight CORS.
      return next.handle(req);
    }
    if (req.url.startsWith(this.trala.postTralalereUrl)){
      // sans token, on n'envoie pas d'en-tête "access-token: undefined" :
      // l'API répond alors 403 et le guard peut router vers login/unauthorized.
      customHeaders = this.trala.accesstoken
        ? req.headers.set("access-token", this.trala.accesstoken)
        : req.headers;
    } else {
      customHeaders = req.headers.set("ajaxMathia", "1");
      customHeaders = customHeaders.set("Locale", this.locale);
    }
    tokenReq = req.clone({
      headers: customHeaders
    });
    return next.handle(tokenReq);
  }
}
